export function isCLA(): boolean {
  return (
    document.location.hostname.startsWith("inno.") ||
    document.location.hostname.startsWith("inno-concept.")
  );
}
export function isPLA(): boolean {
  return document.location.hostname.startsWith("inno-product.");
}
